/**
 * PerformanceState
 * @author ftgibran
 */
export enum PerformanceState {
  HIDDEN,
  DATA,
  ORIGEM,
  EMBARCADOR,
  BI,
}
